import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {ElementTestId} from '@Tests/tests.types';
import {useAppSelector} from '@/hooks';
import {getPagePlaybackIcon, isPagePlaying} from '@Components/poster-editor/poster-editor-reducer';
import {onPosterPause} from '@Components/poster-editor/library/poster-editor-library';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';

interface PagePlayPauseButtonProps {
  pageId: string;
}

export function PagePlayPauseButton(props: PagePlayPauseButtonProps): ReactElement | null {
  const isPlaying = useAppSelector((state) => isPagePlaying(state, props.pageId));
  const icon = useAppSelector((state) => getPagePlaybackIcon(state, props.pageId));

  const onPlayPauseClick = (): void => {
    if (!isPlaying) {
      trackPosterBuilderGA4Events(GA4EventName.PLAY_PAGE);
      void window.posterEditor?.whiteboard?.play(props.pageId);
    } else {
      onPosterPause();
    }
  };

  return (
    <Icon
      onClick={onPlayPauseClick}
      icon={icon}
      type={IconType.GHOST_UNCOLORED}
      size={IconSize.SIZE_ICON_16}
      shape={IconShape.SQUARE}
      data-testid={ElementTestId.POSTER_EDITOR_WEB_BOTTOM_BAR_PLAY_PAUSE_BUTTON}
    />
  );
}
